import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/contexts/LanguageContext";

export function PublicFooter() {
  const { t } = useLang();
  return (
    <footer className="text-[color:var(--bk-navy)] border-t border-[color:var(--bk-line)]" style={{ background: "var(--bk-ivory-2)" }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-9 h-9 rounded-md grid place-items-center brand-heading font-bold text-[13px]" style={{ background: "var(--bk-navy)", color: "#fff" }}>BK</div>
            <div>
              <div className="brand-heading font-semibold">{t("app_name")}</div>
              <div className="text-[10px] uppercase tracking-widest opacity-60">MP MSME Credit Exchange</div>
            </div>
          </div>
          <p className="text-sm opacity-75 leading-relaxed max-w-sm">
            {t("footer_desc")}
          </p>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-widest opacity-60 mb-3">{t("footer_platform")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/how-it-works" className="hover:text-[color:var(--bk-saffron)]">{t("how_it_works")}</Link></li>
            <li><Link to="/for-msmes" className="hover:text-[color:var(--bk-saffron)]">{t("for_msmes")}</Link></li>
            <li><Link to="/for-banks" className="hover:text-[color:var(--bk-saffron)]">{t("for_banks")}</Link></li>
            <li><Link to="/schemes" className="hover:text-[color:var(--bk-saffron)]">{t("footer_schemes")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-widest opacity-60 mb-3">{t("footer_compliance")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className="hover:text-[color:var(--bk-saffron)]">{t("footer_privacy")}</Link></li>
            <li><Link to="/terms" className="hover:text-[color:var(--bk-saffron)]">{t("footer_terms")}</Link></li>
            <li><Link to="/disclaimer" className="hover:text-[color:var(--bk-saffron)]">{t("footer_disclaimer")}</Link></li>
            <li><Link to="/grievance" className="hover:text-[color:var(--bk-saffron)]">{t("footer_grievance")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-widest opacity-60 mb-3">{t("footer_contact")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contact" className="hover:text-[color:var(--bk-saffron)]">{t("footer_reach")}</Link></li>
            <li className="opacity-70">support@bharatkosh.demo</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[color:var(--bk-line)]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 text-[12px] opacity-65 leading-relaxed">
          {t("footer_legal")}
        </div>
      </div>
    </footer>
  );
}
